import { kcContext } from 'config/kc-context';
import { UrlObjectParams, addParamsToUrl, fixUrlLocalProtocol } from 'utils/url-utils';

type UrlName = keyof typeof kcContext.url;

export function useKcUrlEffect(urlName: UrlName, params?: UrlObjectParams ) {
  return useUrlEffect(kcContext?.url?.[urlName], params);
}

export function useUrlEffect(url: string, params?: UrlObjectParams ) {
  const urlWithFixedProtocol = fixUrlLocalProtocol(url);
  const urlWithParams = addParamsToUrl(urlWithFixedProtocol, params);

  return urlWithParams;
}
